import type { ResponsiveValue, TLengthStyledSystem } from "styled-system";
import { system } from "styled-system";
import type * as CSS from "csstype";
import type { ExactTheme } from "src/lib/emotion/theme.ts";

export interface GapProps {
  gap?:
    | ResponsiveValue<CSS.Property.Gap<TLengthStyledSystem>, ExactTheme>
    | undefined;
}

const defaults = {
  space: [0, 4, 8, 16, 32, 64, 128, 256, 512],
};

const config = {
  gap: {
    property: "gap",
    scale: "space",
    defaultScale: defaults.space,
  },
};

// @ts-ignore
export const gap = system(config);
